<template>
  <ControlUnit
    :title="$t('control.panel.timeout_mode.title')"
    :tooltip="$t('control.panel.timeout_mode.tooltip')"
  >
    <label
      class="input-checkbox"
    >
      <input
        v-model="currentTimeoutMode"
        @change="toggleTimeoutMode($event)"
        type="checkbox"
        class="input-checkbox__input"
        :true-value="1"
        :false-value="0"
      />
      <span>{{$t('control.panel.timeout_mode.input_label')}}</span>
    </label>

    <input
      v-if="currentTimeoutMode === 1"
      v-model="currentTimeoutValue"
      class="input-input__input"
      type="number"
      min="0"
      step="1000"
      placeholder="ms"
    />

  </ControlUnit>
</template>

<script>
import { computed, onMounted } from 'vue';
import {useStore} from "vuex";

import ControlUnit from "@/views/Control/ControlPanel/ControlUnit/ControlUnit.vue";
import useStateController from "@/views/Control/ControlPanel/ControlUnit/useStateController";
import useRouteController from "@/views/Control/ControlPanel/ControlUnit/useRouteController";
import {runAllWithData} from "@/helpers/functional";


export default {
  components: {
    ControlUnit,
  },

  setup() {
    const timeoutMode = 'timeout-mode';
    const timeoutValue = 'timeout-value';
    const store = useStore();

    const currentTimeoutMode = computed({
      get() {
        return store.state.control.timeout_mode;
      },
      async set(val) {
        await changeHandler({
          type: timeoutMode,
          value: val,
        })
      }
    });
    const currentTimeoutValue = computed({
      get() {
        return store.state.control.timeout_value;
      },
      set(val) {
        changeHandler({
          type: timeoutValue,
          value: val,
        })
      }
    });

    const { changeControlHandler } = useStateController();

    const { setRouteTypeValue, getRouterQueryValue } =
      useRouteController('Control');

    const changeHandler = runAllWithData(
      changeControlHandler,
      setRouteTypeValue
    );

    function toggleTimeoutMode(event) {
      if(event?.returnValue) {
        changeHandler({
          type: timeoutValue,
          value: store.state.control.timeout_value,
        })
      }
    }

    onMounted(() => {
      changeControlHandler({
        type: timeoutMode,
        value: Number(getRouterQueryValue(timeoutMode)),
      });

      changeControlHandler({
        type: timeoutValue,
        value: Number(getRouterQueryValue(timeoutValue)),
      });
    });

    return {
      timeoutMode,
      timeoutValue,
      currentTimeoutMode,
      currentTimeoutValue,
      changeHandler,
      toggleTimeoutMode,
    };
  }
}
</script>

<style lang="scss">
.input-checkbox {
  $this: 'input-checkbox';
  font-size: 14px;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 5px;
  }

  &__input {
    margin-right: 8px;
  }
}
</style>